
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[news]",
      function () {
        return require("private-next-pages/news/[news]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[news]"])
      });
    }
  